import { put } from 'redux-saga/effects';
import { closeModal } from 'lib/ui/Modal';

export const DICT_EDITOR_MODAL = 'dictEditorModal';
